/**
 * Presentational: "Set Locations Standards" card with heading and conditional content.
 * Single Responsibility: layout and heading; shows LocationsPanel or LocationsEmptyState.
 * Interface Segregation: receives only the props needed to render the right child.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { LocationsPanel } from '../../../components/organizationLocations/LocationsPanel';
import { LocationsEmptyState } from '../../../components/standards/LocationsEmptyState';
import { PAGE_COPY, PANEL_CARD_CLASS } from '../constants';

const HEADING_CLASS =
  'font-[\'Roboto:SemiBold\',sans-serif] font-semibold text-lg mb-6 text-black';
const HEADING_STYLE = { fontVariationSettings: "'wdth' 100" };

export function LocationsStandardsSection({
  organizationId,
  queryScope,
  selectedFacilityIds,
  isSingleFacilitySelected,
  heading = PAGE_COPY.LOCATIONS_STANDARDS_HEADING,
}) {
  return (
    <div className={`${PANEL_CARD_CLASS} p-6 min-h-[400px]`}>
      <h3 className={HEADING_CLASS} style={HEADING_STYLE}>
        {heading}
      </h3>
      {isSingleFacilitySelected ? (
        <LocationsPanel
          organizationId={organizationId}
          queryScope={queryScope}
          selectedFacilityIds={selectedFacilityIds}
          onLocationsChange={() => {}}
          readOnlyMode={true}
          showCleaningStandards={true}
        />
      ) : (
        <LocationsEmptyState selectedCount={selectedFacilityIds.length} />
      )}
    </div>
  );
}

LocationsStandardsSection.propTypes = {
  organizationId: PropTypes.string,
  queryScope: PropTypes.string.isRequired,
  selectedFacilityIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  isSingleFacilitySelected: PropTypes.bool.isRequired,
  heading: PropTypes.string,
};
